<template>
  <div class="table-manage-box">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="screen">
          <p>订单状态：</p>
          <p>{{ statusMap[main.status] }}</p>
        </div>
        <div class="sub_txt">
          <div class="main_txt">商户信息</div>
          <div class="txt">
            商户名称：
            <p v-text="address.name"></p>
          </div>
          <div class="txt">
            商户ID：
            <p v-text="address.phone"></p>
          </div>
        </div>
        <div class="sub_txt">
          <div class="main_txt">收货信息</div>
          <div class="txt">
            收货人：
            <p v-text="address.name"></p>
          </div>
          <div class="txt">
            联系方式：
            <p v-text="address.phone"></p>
          </div>
          <div class="txt">
            收货地址：
            <p v-text="getAddress()"></p>
          </div>
        </div>
        <div class="sub_txt" v-if="logisticList.length">
          <div class="main_txt">物流信息</div>
          <div v-for="(logistic, index) in logisticList" :key="logistic.id" :style="{marginTop: index > 0 ? '40px' : '0px'}">
            <div class="txt">发货日期：{{ main.deliverTime || "无" }}</div>
            <div class="txt">物流公司：{{ logistic.company }}</div>
            <div class="txt">运单编号：{{ logistic.code }}</div>
          </div>
        </div>
        <div class="sub_txt" v-else>
          <div class="main_txt">物流信息</div>
          <div>
            <div class="txt">无</div>
          </div>
        </div>
        <div class="sub_txt">
          <div class="main_txt">订单详情</div>
          <div class="horizontal">
            <div class="vertical order-detail">
              <!-- <div class="txt">
                购买人：
                <p v-text="main.nickname"></p>
              </div> -->
              <div class="txt">
                用户ID：
                <p v-text="main.uid"></p>
              </div>
              <!-- <div class="txt">
                用户身份：
                <p>{{ main.role }}</p>
              </div>
              <div class="txt">
                联系电话：
                <p v-text="main.phone"></p>
              </div> -->
              <div class="txt">
                买家留言：
                <p v-text="address.remark || '无'"></p>
              </div>
              <div class="txt">
                订单编号：
                <p v-text="main.oid"></p>
              </div>
            </div>
            <div style="flex: 1">
              <div class="txt">
                下单时间：
                <p v-text="main.created"></p>
              </div>
              <div class="txt" v-if="[8, 16, 18].includes(main.status)">
                付款时间：
                <p v-text="main.payTime"></p>
              </div>
              <!-- <div class="txt" v-if="[8, 16, 18].includes(main.status)">
                支付方式：
                <p v-text="main.payTime"></p>
              </div> -->
              <div class="txt" v-if="[16, 18].includes(main.status)">
                发货时间：
                <p v-text="main.deliverTime"></p>
              </div>
              <div class="txt" v-if="[18].includes(main.status)">
                收货时间：
                <p v-text="main.confirmTime"></p>
              </div>
            </div>
          </div>
          <div class="vertical sub_txt1">
            <el-table
              :data="skuList"
              class="order-table table no-border-table"
              id="table"
              ref="multipleTable"
              :header-cell-style="{
                border: 'none',
                color: '#333',
                background: '#f6f6f6',
                borderBottom: '1px solid #E8E8E8',
                height: '54px',
              }"
              :row-style="{
                height: '54px',
              }"
            >
              <el-table-column prop="id" label="序号">
                <template slot-scope="scope">
                  <p>{{ scope.$index + 1 }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="user" label="商品主图">
                <template slot-scope="scope">
                  <img :src="scope.row.masterPic" />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称"> </el-table-column>
              <el-table-column prop="attrs" label="规格">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.attrs" :key="index">
                    <p>{{ item.keyName }}：{{ item.value }};</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格"> </el-table-column>
              <el-table-column prop="num" label="数量"> </el-table-column>
            </el-table>
            <div class="horizontal price">
              <div class="color_red">全部金额：¥ {{ main.payment }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
// let that;
export default {
  name: 'orderDetail',
  components: { Header },
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '订单管理',
        secondTitle: '订单详情'
      },
      statusMap: {
        2: '待支付',
        8: '待发货',
        10: '已备货',
        16: '待收货',
        18: '已收货'
      },
      typeList: {},
      statusList: [], // 状态列表
      address: {},
      integral: {},
      logisticList: [],
      logistic: {},
      main: {},
      skuList: []
    };
  },
  filters: {},
  async created() {
    // that = this;
    this.getOrderInfo();
  },
  methods: {
    getOrderInfo() {
      this.isLoading = true;
      this.httpGet(this.$root.orderDetail, {
        oid: +this.$route.query.id
      }).then(
        (res) => {
          this.address = res.address;
          this.integral = res.integral;
          this.logisticList = res.logisticList || [];
          this.main = res.main;
          this.skuList = res.skuList;
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
    },
    getAddress() {
      return (
        this.address.provinceStr +
        this.address.cityStr +
        this.address.countyStr +
        this.address.address
      );
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.table-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;
}

.container {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  flex-y(flex-start, flex-start);
  padding: 24px;

  // content 表格
  .content {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    border-radius: 2px;
    flex-y(flex-start, flex-start);
    background: #f5f5f5;
  }
}

.screen {
  width: calc(100% - 30px);
  background: white;
  padding: 30px 15px;
  flex-x(flex-start);
  margin-top: margin10;
  margin-bottom: margin10;

  .el-input {
    width: 300px;
    margin: 0 margin10;
  }

  p {
    word(14px, btn-color);
  }
}

.el-table {
  width: calc(100% - 10px) !important;
  margin-top: 10px;
  border();
  font-size: 12px;

  img {
    width: 60px;
    height: 60px;
  }

  .el-icon-star-on {
    color: yellow;
  }
}

.footer {
  width: calc(100% - 30px);
  min-width: 600px;
  padding: 10px 0 0 15px;
  flex-x();

  .el-button {
    margin-left: 10px;
  }
}

.divider {
  background-color: bk;
  width: 100%;
  height: 2px;
  margin: 10px 0;
}

.vertical {
  flex-y();
}

.horizontal {
  flex-x(flex-start, flex-start);
}

.order-detail {
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 80px;
}

.sku {
  height: 45px;
  justify-content: space-around;
  min-width: 900px;
  border-bottom: solid 1px #dddddd;
}

.price {
  align-self: flex-end;
  height: 30px;
  margin-right: 30px;
  margin-top: 10px;
}

.sub_txt {
  color: #666666;
  font-size: 14px;
  width: 100%;
  padding: 25px 15px 10px;
  background: white;
  margin-bottom: 10px;
}

.sub_txt1 {
  color: #666666;
  font-size: 14px;
  width: 1000px;
  padding-left: 60px;
}

.main_txt {
  color: #101010;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.color_red {
  color: btn-color;
}

.txt {
  flex-x();
  justify-content: flex-start;
  margin: 3px;
  line-height: 2;
  padding-left: 60px;
}
</style>
